import { defineComponent as _defineComponent } from 'vue'
import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import BuilderMobileStepPagination from "./BuilderMobileStepPagination.vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderStepMobileNavigation',
  props: {
    steps: {},
    currentStep: {},
    houseDesign: {}
  },
  emits: ["select-next", "select-prev"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;

  const emit = __emit;

  const onSelectNext = () => {
    emit("select-next");
  };

  const onSelectPrev = () => {
    emit("select-prev");
  };

const __returned__ = { props, emit, onSelectNext, onSelectPrev, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, BuilderMobileStepPagination, get HouseDesignInterface() { return HouseDesignInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})